import React from 'react';
import {Redirect} from 'react-router';
import axios from 'axios';
import moment from 'moment';

import trash from '../../../assets/images/VVM-DELETE_GRAY_DROP-SHADOW.PNG';
import message from '../../../assets/images/CX-ICONS-SENT_GRY_150x150.png';
import forward from '../../../assets/images/VVM-FORWARD_GRAY_DROP-SHADOW.PNG';
import save from '../../../assets/images/VVM-SAVE_GRAY_DROP-SHADOW.PNG';
import play from '../../../assets/images/VVM-PLAY_GRAY_DROP-SHADOW.PNG';
import pause from '../../../assets/images/VVM-PAUSE_GRAY_DROP_SHADOW.png';

import Auxi from '../../../hoc/Auxi';
import Spinner from '../../../components/Widgets/Spinner';
import Toast from '../../../components/Widgets/CustomToast';
import Modal from '../../../components/Widgets/Modal/Modal'
import AudioPlayer from 'react-h5-audio-player';

import '../../../assets/css/style.css';

class VoiceMessages extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            recordType: 'vmail/new',
            voiceMails: [],
            username: "Daniyal",
            loading: true,
            audioSource: '',
            showModal: false,
        };
        this.playPauseRef = [];
    }

    customStyles = {
      content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
      }
    };

    getNewMessages = (uType, userName, password, cloudId) =>{
      this.infoOnExistingUser(uType, userName, password, cloudId)
      const payLoad = new FormData();
      payLoad.append('user', userName.split("@")[0]);
      payLoad.append('domain', userName.split("@")[1]);
      payLoad.append('type', "vmail/new");
      payLoad.append('cloud_id', cloudId);

      axios.post(`${process.env.REACT_APP_API_URL}?format=json&object=audio&action=read&utype=${uType}&cloud_username=${userName}&cloud_password=${password}`, payLoad)
        .then(response=>{
            this.createDataTable(response.data);
        })
        .catch(err=>{
            Toast.error(err.message);
            this.setState({loading: false})
        });

    }

    getSavedMessages = () =>{
      
      const payLoad = new FormData();
      payLoad.append('user', this.state.username.split("@")[0]);
      payLoad.append('domain', this.state.username.split("@")[1]);
      payLoad.append('type', "vmail/save");
      payLoad.append('cloud_id', this.state.cloudId);

      
      axios.post(`${process.env.REACT_APP_API_URL}?format=json&object=audio&action=read&utype=${this.state.uType}&cloud_username=${this.state.username}&cloud_password=${this.state.password}`, payLoad)
        .then(response=>{
            this.createDataTable(response.data);


        })
        .catch(err=>{
            Toast.error(err.message);
        });

    }

    getTrashedMessages = () =>{
      
      const payLoad = new FormData();
      payLoad.append('user', this.state.username.split("@")[0]);
      payLoad.append('domain', this.state.username.split("@")[1]);
      payLoad.append('type', "trash");
      payLoad.append('cloud_id', this.state.cloudId);

      axios.post(`${process.env.REACT_APP_API_URL}?format=json&object=audio&action=read&utype=${this.state.uType}&cloud_username=${this.state.username}&cloud_password=${this.state.password}`, payLoad)
        .then(response=>{
            this.createDataTable(response.data);


        })
        .catch(err=>{
            Toast.error(err.message);
        });

    }

    getDeviceInfo = (userName, uType, password, cloudId) => {


      const payLoad = new FormData();
      payLoad.append('device', "sip:" + userName.split("@")[0] + "@" + userName.split("@")[1]);
      payLoad.append('domain', userName.split("@")[1]);
      payLoad.append('cloud_id', cloudId);
      
      axios.post(`${process.env.REACT_APP_API_URL}?format=json&object=device&action=read&utype=${uType}&cloud_username=${userName}&cloud_password=${password}`, payLoad)
        .then(response=>{
            this.setState({username: (response.data[0].aor_user) +'@'+((response.data[0].sub_login).split("@")[1])});
            this.getNewMessages(uType, (response.data[0].aor_user) +'@'+((response.data[0].sub_login).split("@")[1]), password, this.state.cloudId);

        })
        .catch(err=>{
            Toast.error(err.message);
        });

    }

    componentDidMount(){

      let username = this.props.username
        let cloudId = this.props.cloudId;
        
        this.setState({ username: username });
        this.setState({ cloudId: cloudId });
        this.setState({password: "dupm"})
        // this.checkIfShowEngage(username, cloudId)

        let uType = 's';
        
        //this.getDeviceInfo(username, username.split("@")[1], uType, "dupm", cloudId);
        this.getNewMessages(uType, username, "dupm", cloudId);
        this.setState({ uType: uType });

    }
    toHHMMSS = (seconds) => {
      var sec_num = parseInt(seconds, 10); // don't forget the second param
      var hours   = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);

      if (hours   < 10) {hours   = "0"+hours;}
      if (minutes < 10) {minutes = "0"+minutes;}
      if (seconds < 10) {seconds = "0"+seconds;}
      if(hours == "00"){
        return minutes+':'+seconds;
      }
      return hours+':'+minutes+':'+seconds;
    }
    formatNumber = (number) =>{
      if(number.length < 10){
        return number;
      }

      return "(" + (number.slice(-10)).slice(0,3)+") "+(number.slice(-10)).slice(3,6)+"-"+(number.slice(-10)).slice(6);
    }
    createDataTable = (dataFromApi) => {

      var jsonArray = [];
      for(var key in dataFromApi){
        const date = moment.utc(dataFromApi[key]["filedate"]).toDate();
        dataFromApi[key]["key"] = key;
        const searchRegExp = /amp;/g;
        dataFromApi[key]["remotepath"] = dataFromApi[key]["remotepath"].replace(searchRegExp,"");
        dataFromApi[key]["filedate"] = moment(date).local().format('MMM Do, h:mm a');
        dataFromApi[key]["NmsRecDuration"] = this.toHHMMSS(dataFromApi[key]["NmsRecDuration"]);
        dataFromApi[key]["DisplayNumber"] = this.formatNumber(dataFromApi[key]["NmsAni"]);
        dataFromApi[key]["LinkNumber"] = dataFromApi[key]["NmsAni"].replace("+","");
        jsonArray.push(dataFromApi[key]);
      }
      let voiceMails = jsonArray.map((row)=>{
                return (
                  <Auxi>
                    
                    <tr>
                      <td className="voice-mail-btn-td">
                        <div className="voice-mail-btn-div">

                          <a ref={(ref) => this.playPauseRef[(row.remotepath + "pause")] = ref}
                            onClick={this.playHandler} data-id2={row.remotepath} 
                            title="Play">
                            {/* <FontAwesomeIcon 
                              icon={faPlayCircle} className="data-table-icon"/> */}
                              <img className="img-icons" src={play}/>
                          </a>
                          
                          <a ref={(ref) => this.playPauseRef[(row.remotepath + "play")] = ref}
                            onClick={this.pauseHandler} data-id2={row.remotepath} 
                            title="Stop" style={{display:"none"}}>
                            {/* <FontAwesomeIcon 
                              icon={faPauseCircle} className="data-table-icon"/> */}
                              <img className="img-icons" src={pause}/>
                          </a>
                          
                          <a onClick={this.forwardHandler} data-id={row.key}
                              title="Forward">
                            {/* <FontAwesomeIcon icon={faShare} className="data-table-icon"/> */}
                            <img className="img-icons" src={forward}/>

                          </a>
                          
                          <a onClick={this.saveHandler} data-id={row.key}
                              title="Save">
                            {/* <FontAwesomeIcon icon={faSave} className="data-table-icon"/> */}
                            <img className="img-icons" src={save}/>
                          </a>

                          <a onClick={e => this.messageToNumber(row.FromUser)} data-id={row.key}
                              title="Delete">
                            {/* <FontAwesomeIcon icon={faTrash} className="data-table-icon"/> */}
                            <img className="img-icons" src={message}/>
                          </a>
                            
                          <a onClick={this.deleteHandler} data-id={row.key}
                              title="Delete">
                            {/* <FontAwesomeIcon icon={faTrash} className="data-table-icon"/> */}
                            <img className="img-icons" src={trash}/>
                          </a>
                          
                        
                        </div>

                      </td>
                    </tr>

                    <tr className="voice-mail-borderNone">
                      <td>
                        <div className="voice-mail-row2 voice-mail-displayInfo">
                          <a href={"sip:"+row.LinkNumber+"?dialAction=autoCall"}>
                            <span>{row.DisplayNumber}</span>
                          </a>
                          <span>
                            {
                              row.VmailForwarded ?

                                <span className="fwd-label" title={"Forwarded from " +row.VmailForwarded}>
                                  Fwd
                                </span>

                              :
                                null

                            }
                            {row.FromName}
                          </span>
                        </div>
                      </td>  

                    </tr>
                    <tr className="voice-mail-borderNone">
                      <td>
                        <div className="voice-mail-row2">
                          <span>{row.filedate}</span>
                          <span>{row.NmsRecDuration}</span>
                        </div>
                      </td>
                    </tr>
                    
                    {row.transcription ?
                      <tr>
                        <td className="voice-message-text" colspan="4">
                            <span>{row.transcription}</span>
                        </td>
                      </tr>
                      : null
                    }

                  </Auxi>

                );
            });
            this.setState({voiceMails: voiceMails});
            this.setState({loading: false});
    }

    messageToNumber = (number) => {
        window.location.href = "cloudsip:"+number+"?dialAction=text"
    }

    deleteHandler = (event) =>{

      const payLoad = new FormData();
      payLoad.append('owner', this.state.username.split("@")[0]);
      payLoad.append('owner_domain', this.state.username.split("@")[1]);
      payLoad.append('type', this.state.recordType);
      payLoad.append('index', event.currentTarget.getAttribute("data-id"));
      payLoad.append('cloud_id', this.state.cloudId);
      

      axios.post(`${process.env.REACT_APP_API_URL}?format=json&object=audio&action=delete&utype=${this.state.uType}&cloud_username=${this.state.username}&cloud_password=${this.state.password}`, payLoad)
        .then(response=>{

          this.refreshData(this.state.recordType);

        })
        .catch(err=>{
            Toast.error(err.message);
        });

    }

    saveHandler = (event) =>{
      
      const payLoad = new FormData();
      payLoad.append('owner', this.state.username.split("@")[0]);
      payLoad.append('owner_domain', this.state.username.split("@")[1]);
      payLoad.append('type', this.state.recordType);
      payLoad.append('index', event.currentTarget.getAttribute("data-id"));
      payLoad.append('cloud_id', this.state.cloudId);

      axios.post(`${process.env.REACT_APP_API_URL}?format=json&object=audio&action=update&utype=${this.state.uType}&cloud_username=${this.state.username}&cloud_password=${this.state.password}`, payLoad)
        .then(response=>{

          this.refreshData(this.state.recordType);

        })
        .catch(err=>{
            Toast.error(err.message);
        });

    }

    playHandler = (event) =>{
      //event.removeClass('feather');
      if(this.state.audioSource !== ''){
        this.playPauseRef[(this.state.audioSource + "play")].setAttribute("style", "display: none;");
        this.playPauseRef[(this.state.audioSource + "pause")].setAttribute("style", "display: bold;");
      }
      this.playPauseRef[(event.currentTarget.getAttribute('data-id2') + "pause")].setAttribute("style", "display: none;");
      this.playPauseRef[(event.currentTarget.getAttribute('data-id2') + "play")].setAttribute("style", "display: bold;");
      this.setState({audioSource: event.currentTarget.getAttribute('data-id2')})

    }

    pauseHandler = (event) =>{
      this.playPauseRef[(event.currentTarget.getAttribute('data-id2') + "play")].setAttribute("style", "display: none;");
      this.playPauseRef[(event.currentTarget.getAttribute('data-id2') + "pause")].setAttribute("style", "display: bold;");
      this.setState({audioSource: ''});
    }

    messageEnded = () => {
      if(this.state.audioSource != ''){
        this.playPauseRef[(this.state.audioSource + "play")].setAttribute("style", "display: none;");
        this.playPauseRef[(this.state.audioSource + "pause")].setAttribute("style", "display: bold;");
        this.setState({audioSource: ''});
      }
    }

    refreshData = (value) => {
      if(this.state.audioSource !== ''){
        this.playPauseRef[(this.state.audioSource + "play")].setAttribute("style", "display: none;");
        this.playPauseRef[(this.state.audioSource + "pause")].setAttribute("style", "display: bold;");
        this.setState({audioSource: ''});
        this.playPauseRef = [];
      }
      if(value === "vmail/save"){
        this.getSavedMessages();
      }
      else if (value === "vmail/new") {
        this.getNewMessages(this.state.uType, this.state.username, this.state.password, this.state.cloudId);
      }
      else{
        this.getTrashedMessages();
      }
    }

    selectChangeHandler = (event) =>{

      this.refreshData(event.currentTarget.value);
      this.setState({recordType: event.currentTarget.value});

    }

    forwardHandler =(event) => {
      this.setState({forwardIndex: event.currentTarget.getAttribute("data-id")})
      this.setState({showModal:true});
    }

    onChangeHandler = (event) => {
      this.setState({[event.currentTarget.name]:event.currentTarget.value});
    }

    closeModal = (event) =>{
      this.setState({to_user:null});
      this.setState({showModal:false});
    }

    sendMessage = () => {
      if(!this.state.to_user || this.state.to_user === ''){
        return
      }

      const payLoad = new FormData();
        payLoad.append('owner', this.state.username.split("@")[0]);
        payLoad.append('owner_domain', this.state.username.split("@")[1]);
        payLoad.append('type', this.state.recordType);
        payLoad.append('index', this.state.forwardIndex);
        payLoad.append('forward', this.state.to_user);
        payLoad.append('cloud_id', this.state.cloudId);

      axios.post(`${process.env.REACT_APP_API_URL}?format=json&object=audio&action=update&utype=${this.state.uType}&cloud_username=${this.state.username}&cloud_password=${this.state.password}`, payLoad)
        .then(response=>{

          this.setState({to_user:null});
          this.setState({showModal:false});
          Toast.success("Forwarded Successfully!");

        })
        .catch(err=>{
          Toast.error(err.message);
        });
    }

    downloadHandler = (event) =>{
      window.location.href = event.currentTarget.getAttribute("data-id");
    }
    fetchMessagesHandler = () => {
        window.location.reload();
    }

    infoOnExistingUser = (uType, userName, password, cloudId) => {
      let payLoad = new FormData();
      payLoad.append('domain', userName.split("@")[1]);
      payLoad.append('user', userName.split("@")[0]);
      payLoad.append('fields', "callid_nmbr,user,domain,dir,email,first_name,last_name");
      payLoad.append('cloud_id', cloudId);
      
      const url = "?format=json&object=subscriber&action=read&utype=" + uType + "&cloud_password=" +password + "&cloud_username=" + userName;

      axios.post(process.env.REACT_APP_API_URL + url, payLoad)
      .then(response=>{
          
          if(response.data[0]){
            this.setState({smsani: response.data[0].callid_nmbr})
            this.setState({ownContact: response.data[0]}) 
          }
          
      })
      .catch(err=>{
          Toast.error(err.message);
      });
    }

    render() {

        let redirect = null;

        return(
            <Auxi>
                {/*redirect*/}
								{/*<ReactAudioPlayer
									src={audioFile}
									controls
									showJumpControls=false
									showDownloadProgress=false


								/>*/}
                <Modal
                  modalIsOpen={this.state.showModal}
                  closeModal={this.closeModal}
                  onChangeHandler = {this.onChangeHandler}
                  sendMessage = {this.sendMessage}
                  toUser = {this.state.to_user}
                  />

                  <AudioPlayer
                    autoPlay
                    preload={"none"}
                    src={this.state.audioSource}
                    onEnded={e => this.messageEnded()}
                  />

                <div className = "MainIndexApp">
                  <div className="row voice-message-layout">
                    <div className="col-xs-0 col-md-2"> </div>
                    <div className = "col-xs-12 col-md-8">
                        <div className="page-header customTitleMiddle">
                            <h3 className="m-b-10">
                                {this.state.loading
                                  ? <Spinner data="" />
                                : null
                                }
                            </h3>
                        </div>
                        <div className="row form-group">
                          <div className="col-xs-4">
                            <select className="form-control"
                              onChange={this.selectChangeHandler}
                              value={this.state.recordType} name="exporter_type">

                              <option value="vmail/new"> New </option>
                              <option value="vmail/save"> Saved </option>
                              <option value="trash"> Trash </option>

                            </select>
                          </div>
                        </div>
                        <div className="voice-messages-table">
                          { (this.state.voiceMails).length ?
                            <table className="table">
                              <tbody>


                                {this.state.voiceMails}
                              </tbody>
                              </table>
                              :
                              <div className="nonecreated">
                                <h3>You have no {(this.state.recordType).split("/")[1]} messages.</h3>
                              </div>
                            }

                        </div>
                    </div>
                    <div className="col-xs-0 col-md-2"></div>
                  </div>
                </div>
            </Auxi>

        );

    }

}

export default VoiceMessages;
